import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useGuestNavigationStore = defineStore('guestNavigation', () => {
  const learnMoreResidencySlug = ref<string | null>(null)

  function markLearnMoreEntry(slug: string) {
    learnMoreResidencySlug.value = slug
  }

  function isLearnMoreEntry(slug: string | string[] | undefined): boolean {
    return typeof slug === 'string' && learnMoreResidencySlug.value === slug
  }

  return { learnMoreResidencySlug, markLearnMoreEntry, isLearnMoreEntry }
})
